<template>
  <div id="Chat">
    <div class="chat">
      <table>
        <thead>
          <th></th>
          <th>CHAT</th>
        </thead>
        <tbody id="chat-table">
          <tr v-for="(message, index) in messages" :key="index">
            <td id="td-name" v-bind:class="{ me: message.name == user.name }">{{message.name}}</td>
            <td id="td-message">{{message.message}}</td>
          </tr>
        </tbody>
      </table>
      <div class="flex">
        <input
                class="input-text input-message message-content"
                id="input-message"
                type="text"
                name="message"
                v-model="message"
                v-on:keyup.enter="submit"
              />
        <game-button @clicked="submit()" class="simple-button name-message">INVIA</game-button>
      </div>
    </div>
  </div>
</template>
<script>
import GameButton from "@/components/Button";
import { mapGetters } from "vuex";
export default {
  name: "Chat",
  components: {
    GameButton,
  },
  props: {
    messages: {
      type: Array,
      required: true
    },
    game: {
      type: Object,
      required: false
    },
  },
  data() {
    return {
      message: "",
    };
  },
    computed: {
    ...mapGetters({ 
        user: "user/user",
    })
  },
  mounted() {
    if (this.game) {
      window.Echo.private('chat-' + this.game.id).listenForWhisper('typing', (e) => {
        this.$store.commit("chat/addMessage", e);
      });
    } else {
      window.Echo.private('chat').listenForWhisper('typing', (e) => {
        if (e.userId != this.user.id) {
          this.$store.commit("chat/addMessageExternal", e);
        }
      });
    }
  },
  beforeDestroy(){
    if (this.game) {
      window.Echo.private("chat-" + this.game.id).stopListening('typing');
    } else {
      window.Echo.private("chat").stopListening('typing');
      this.$store.commit("chat/resetChat");
    }
  },
  methods: {
    submit() {
      const e = {
        message: this.message,
        userId: this.user.id
      }
      if (this.game) {
        window.Echo.private('chat-' + this.game.id).whisper('typing', e);
        this.$store.commit("chat/addMessage", e);
      } else {
        window.Echo.private('chat').whisper('typing', e);
        this.$store.commit("chat/addMessageExternal", e);
      }
      this.message = "";
    }
  }
};
</script>
<style scoped>
.margin-zero {
  margin: 0em;
}
.chat {
  margin-bottom: 1em;
  margin-right: 8px;
  min-width: 300px;
}

table {
  border: solid 6px black;
  border-bottom: none;
  border-collapse: collapse;
  padding: 5px;
  background-color: whitesmoke;
  width: 100%;
}
td {
  padding: 2px;
  text-align: left;
  word-wrap:break-word;
}
th {
  padding: 2px;
  text-align: left;
  background-color: black;
}
tr {
  font-size: 12px;
  font-weight: 600;
  border: solid rgba(32, 58, 36, 0.756) 1px;
}

.me {
  color: coral;
}
.simple-button {
  margin: 0em;
  padding: 0em;
}
.input-message {
  padding: 3px;
  border: solid 4px black;
}
.name-message {
  width: 20%;
}
.input-text {
  border-radius: 0px;
}
.message-content {
  width: -webkit-fill-available;
  width: -moz-available;
}
#td-name {
  max-width: 103px;
  min-width: 103px;
}
#td-message {
  width: 240px;
}

</style>
